import React, { useState } from "react";

export const STORIA_PREVIEW_CHARS = 400;

/** @deprecated Use STORIA_PREVIEW_CHARS */
export const STORIA_MOBILE_PREVIEW_CHARS = STORIA_PREVIEW_CHARS;

/** Word-aware plain-text preview capped at maxChars (includes ellipsis when cut). */
export function plainTextPreview(text, maxChars = STORIA_PREVIEW_CHARS) {
  const plain = String(text || "").trim();
  if (!plain) return "";
  if (plain.length <= maxChars) return plain;
  const cut = plain.slice(0, maxChars);
  const at = cut.lastIndexOf(" ");
  return `${(at > 80 ? cut.slice(0, at) : cut).trim()}…`;
}

/**
 * Collapse long historical text on any viewport.
 * Shows preview + «Continua a leggere» when plain text exceeds maxChars.
 */
export function useHistoricalCollapse(plainText, maxChars = STORIA_PREVIEW_CHARS) {
  const [expanded, setExpanded] = useState(false);
  const length = String(plainText || "").trim().length;
  const needsCollapse = length > maxChars;
  const showPreview = needsCollapse && !expanded;

  return {
    needsCollapse,
    showPreview,
    previewText: showPreview ? plainTextPreview(plainText, maxChars) : null,
    expanded,
    toggle: () => setExpanded((v) => !v),
  };
}

/** @deprecated Use useHistoricalCollapse */
export const useHistoricalMobileCollapse = useHistoricalCollapse;

export function HistoricalCollapseToggle({ expanded, onToggle, className = "" }) {
  return (
    <div className={`flex justify-center mt-4 ${className}`.trim()}>
      <button
        type="button"
        aria-expanded={expanded}
        onClick={onToggle}
        className="inline-flex items-center justify-center rounded-lg border border-borderline bg-white px-4 py-2.5 text-sm font-medium text-terracotta hover:border-terracotta/50 hover:bg-parchment2/40 transition-colors"
        data-testid="storia-collapse-toggle"
      >
        {expanded ? "Mostra meno ⬆️" : "Continua a leggere ⬇️"}
      </button>
    </div>
  );
}
